const stageConfig = {
  client_id: process.env.client_id,
  staticWebSiteUrl: process.env.staticWebSiteUrl,
  apiGwUrl: process.env.apiGwUrl,
  loginApiUrl: process.env.loginApiUrl,
  loginUrlTemplate: process.env.loginUrlTemplate,
  analyticsTrackingId: process.env.analyticsTrackingId,
  captchaSiteKey: process.env.captchaSiteKey,
  MezaheBituahC: process.env.MezaheBituahC,
  MezaheBituah: process.env.MezaheBituah,
  idfLoginUrlTemplate: process.env.idfLoginUrlTemplate,
  HanutC: process.env.HanutC,
  Hanut: process.env.Hanut,
  newFullLoginUrl: process.env.newFullLoginUrl,
  newLoginUrl: process.env.newLoginUrl,
  startPageBlock: process.env.startPageBlock,
  stage: process.env.STAGE,
  guidValue: process.env.guidValue,
  environmentCookieDomain: process.env.environmentCookieDomain,
};

export default stageConfig;
